import { useRouter } from 'next/navigation';
import PriceListCard from './price-list-card';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';

export const PriceListAgency = () => {
  const router = useRouter();
  const { me } = useCustomerStore();

  return (
    <div className="space-y-8">
      {/* Zverejnenie ponuky vzdelávacieho kurzu Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">
          Zverejnenie ponuky vzdelávacieho kurzu
        </h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="1 vzdelávací kurz"
            description="1 mesiac"
            price="120 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="1 vzdelávací kurz"
            description="2 mesiace"
            price="220 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          {/* <PriceListCard
            title="2 vzdelávacie kurzy"
            description="1 mesiac"
            price="220 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="2 vzdelávacie kurzy"
            description="2 mesiace"
            price="400 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          /> */}
          <PriceListCard
            title="Individuálna cenová ponuka"
            description="Pre zverejnenie viac vzdelávacích kurzov na viac mesiacov"
            price="Na vyžiadanie"
            buttonText="Získať ponuku"
            buttonAction={() => {
              router.push('/individualna-ponuka');
            }}
          />
        </div>
      </div>

      {/* Zvýraznenie vzdelávacieho kurzu Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">Zvýraznenie vzdelávacieho kurzu</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="Zvýraznenie"
            description="Presunutie medzi popredné miesta"
            price="60 € bez DPH / 1 mesiac"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
        </div>
      </div>

      {/* Poznámka Section */}
      <div className="mt-8 rounded-lg border border-blue-200 bg-blue-50 p-4">
        <p className="text-sm text-blue-800">
          <strong>Poznámka:</strong> Stredné školy a Stredné Odborné školy majú zverejnenie
          vzdelávacieho kurzu bezplatne.
        </p>
      </div>
    </div>
  );
};
